export enum AgentApplicationStatus {
    ASSIGNED = 'ASSIGNED',
    PENDING_ASSIGNMENT = 'PENDING_ASSIGNMENT',
    RETURNED_FOR_ASSIGNMENT = 'RETURNED_FOR_ASSIGNMENT',
    DECLINED = 'DECLINED',
    ACTIVE = 'ACTIVE',
    FULLY_PAID = 'FULLY_PAID',
}

export enum AgentCommissionType {
    PERCENTAGE = 'PERCENTAGE',
    FIXED_AMOUNT = 'FIXED_AMOUNT',
}

export enum AgentLoanApplicationSalesType {
    MONTHLY = 'MONTHLY',
    WEEKLY = 'WEEKLY',
}
